import { OTS_STAFF_STATUS_FROM_API } from '../constants/ots-staff-status-from-api';
import { IOtsApiBasketItem } from '../interfaces/IOtsApiBasketItem';
import { IOtsApiLocation } from '../interfaces/IOtsApiLocation';
import { IOtsApiOrder } from '../interfaces/IOtsApiOrder';
import { IOtsCartLine } from '../interfaces/IOtsCartLine';
import { IOtsStaffOrder } from '../interfaces/IOtsStaffOrder';
import { OtsApiOrderStatus, OtsLocationKind, OtsStaffOrderStatus } from '../types';

export class OtsStaffOrderUtils {

  public static fromApi(order: IOtsApiOrder, lines: IOtsCartLine[]): IOtsStaffOrder {
    const parsed = order.placedAt ? Date.parse(order.placedAt) : Number.NaN;
    const createdAt = Number.isFinite(parsed) && parsed > Date.UTC(2020, 0, 1)
      ? parsed
      : Date.now();

    return {
      id: order.id,
      status: OtsStaffOrderUtils.statusFromApi(order.status),
      apiStatus: order.status,
      customerName: order.customerName,
      createdAt,
      locationTitle: order.location.name,
      seatNumber: order.seatNumber,
      locationKind: OtsStaffOrderUtils.locationKindFromApi(order.location.kind),
      fulfillmentId: order.fulfillment === 'Pickup' ? 'pickup' : 'delivery',
      lines
    };
  }

  public static cartLineFromApi(line: IOtsApiBasketItem): IOtsCartLine {
    const isPackage = line.itemType === 3 || line.itemType === 'Package' || line.itemType === 'package';
    const productId = isPackage ? `pkg:${line.itemId}` : String(line.itemId);
    const unitPriceCents = Math.round(line.price * 100);
    const packageProductNames = (line.packageProducts ?? [])
      .map(product => product.name?.trim())
      .filter((name): name is string => !!name);

    return {
      productId,
      name: line.name,
      nameKey: `ots.menu.item.${productId}`,
      unitPriceCents,
      qty: line.quantity,
      packageProductNames
    };
  }

  private static statusFromApi(status: string | undefined): OtsStaffOrderStatus {
    if (OtsStaffOrderUtils.isApiStatus(status)) {
      return OTS_STAFF_STATUS_FROM_API[status];
    }

    return 'new';
  }

  private static isApiStatus(status: string | undefined): status is OtsApiOrderStatus {
    return status != null && status in OTS_STAFF_STATUS_FROM_API;
  }

  private static locationKindFromApi(kind: IOtsApiLocation['kind']): OtsLocationKind {
    return kind === 'Restaurant' ? 'restaurant' : 'auditorium';
  }
}
